import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Container, Row, Col, Button, Card } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCreditCard, faPhone, faCommentDots } from '@fortawesome/free-solid-svg-icons';
import './SharedStyleSheet.css';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Header from './Header';

function App() {
    const { t, i18n } = useTranslation();
    return (
        <div className="App">
            <Container fluid className="px-lg-5">
                <Row className="align-items-center jumbotron-container">
                    <Col xs={12} md={6}>
                        <h1 className="display-4">{t("title")}</h1>
                        <p className="lead">{t("subtitle")}</p>
                        <Button as={Link} to="/sign-up" variant="primary" size="lg">{t('signUp')}</Button>
                    </Col>
                    <Col xs={12} md={6}>
                        <img src="https://source.unsplash.com/500x300/?phonecall" alt="Hero" className="img-fluid hero-image" />
                    </Col>
                </Row>
            </Container>

            <Container className="px-lg-5">
                <Row className="mt-5">
                    <Col xs={12}>
                        <h2>{t('howYourFriendCanHelp')}</h2>
                    </Col>
                </Row>

                <Row className="mt-4">
                    <Col xs={12} md={4}>
                        <Card>
                            <Card.Img variant="top" src="https://source.unsplash.com/featured/?programming" />
                            <Card.Body>
                                <Card.Title>{t('programmingHelp')}</Card.Title>
                                <Card.Text>
                                    {t('programmingHelpDesc')}
                                </Card.Text>
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col xs={12} md={4}>
                        <Card>
                            <Card.Img variant="top" src="https://source.unsplash.com/featured/?career" />
                            <Card.Body>
                                <Card.Title>{t('careerGuidance')}</Card.Title>
                                <Card.Text>
                                    {t('careerGuidanceDesc')}
                                </Card.Text>
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col xs={12} md={4}>
                        <Card>
                            <Card.Img variant="top" src="https://source.unsplash.com/featured/?relationships" />
                            <Card.Body>
                                <Card.Title>{t('relationshipAdvice')}</Card.Title>

                                <Card.Text>
                                    {t('relationshipAdviceDesc')}
                                </Card.Text>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>

                <Row className="mt-4">
                    <Col xs={12} md={4}>
                        <Card>
                            <Card.Img variant="top" src="https://source.unsplash.com/featured/?mental-health,wellness" />
                            <Card.Body>
                                <Card.Title>{t('mentalHealthSupport')}</Card.Title>
                                <Card.Text>
                                    {t('mentalHealthSupportDesc')}
                                </Card.Text>
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col xs={12} md={4}>
                        <Card>
                            <Card.Img variant="top" src="https://source.unsplash.com/featured/?fitness" />
                            <Card.Body>
                                <Card.Title>{t('fitnessTips')}</Card.Title>
                                <Card.Text>
                                    {t('fitnessTipsDesc')}
                                </Card.Text>
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col xs={12} md={4}>
                        <Card>
                            <Card.Img variant="top" src="https://source.unsplash.com/featured/?hobbies" />
                            <Card.Body>
                                <Card.Title>{t('hobbyIdeas')}</Card.Title>
                                <Card.Text>
                                    {t('hobbyIdeasDesc')}
                                </Card.Text>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>

                <Row className="mt-5">
                    <Col xs={12}>
                        <h2>{t('howItWorks')}</h2>
                    </Col>
                </Row>
                <Row className="mt-4">
                    <Col xs={12} md={4} className="text-center">
                        <div className="how-it-works-box">
                            <FontAwesomeIcon icon={faCreditCard} size="3x" />
                            <h3>{t('step1')}</h3>
                            <p>{t('step1Desc')}</p>
                        </div>
                    </Col>
                    <Col xs={12} md={4} className="text-center">
                        <div className="how-it-works-box">
                            <FontAwesomeIcon icon={faPhone} size="3x" />
                            <h3>{t('step2')}</h3>
                            <p>{t('step2Desc')}</p>
                        </div>
                    </Col>
                    <Col xs={12} md={4} className="text-center">
                        <div className="how-it-works-box">
                            <FontAwesomeIcon icon={faCommentDots} size="3x" />
                            <h3>{t('step3')}</h3>
                            <p>{t('step3Desc')}</p>
                        </div>
                    </Col>
                </Row>
                <Row className="mt-5">
                    <Col xs={12}>
                        <h2>{t('readyToStart')}</h2>
                        <p>{t('readyToStartDesc')}</p>
                        <Button as={Link} to="/sign-up" variant="primary" size="lg">{t('signUp')}</Button>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default App;